import { ComponentProps } from 'react';

import { ActionRow } from '@pletly/ui';
import i18n from '../../i18n';

export const DeleteAccount = ({ onPress }: Pick<ComponentProps<typeof ActionRow>, 'onPress'>) => {
	const { t } = i18n;

	return (
		<ActionRow
			testID="delete-account-item"
			status="danger"
			title={t('profile.delete-account')}
			subtitle={t('profile.this-action-cannot-be-undone')}
			onPress={onPress}
		/>
	);
};
